import { globalVariables } from "helper/globalVariables";
import { useState, useRef, useEffect, useMemo } from "react";
import { globalClasses } from "helper/globalClasses";
import { externalLink } from "helper/icons";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import SearchBar from "./Components/search";
import Dropdown from "shared/Components/dropdown";
import { ResultCard } from "./Components/ResultCard";
import Modal from "shared/Components/modal";
import Loader from "shared/Components/loader";
import { MobilePagination } from "shared/Components/mobilePagination";
import { useNavigate } from "react-router-dom";
import { EditSitResultCard } from "./Components/EditSitResultCard";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_ALL_REGISTERED_DOGS_SIT,
  UPDATE_DOG_STATUS,
} from "redux/features/editSite/EditSiteApi";
import { debounce } from "lodash";
import { PopUpMessages } from "shared/Components/popUpMessages";
import PageInfo from "shared/Components/pageInfo";
import { useMediaQuery } from "react-responsive";

export const EditSit = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const [getData, { loading, error, data, refetch }] = useLazyQuery(
    GET_ALL_REGISTERED_DOGS_SIT
  );
  const [updateDogStatus] = useMutation(UPDATE_DOG_STATUS);
  const [search, setSearch] = useState("");
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const resultData = data?.getAllRegisteredDogsSIT;
  const filteredTableData = useMemo(() => resultData?.data || [], [resultData]);
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);
  const handlePaginationData = (pages = 1) => {
    setPage(pages);
    localStorage.setItem("editSitePagination", pages);
    getData({
      variables: {
        pageNumber: page,
        pageSize: 10,
        search,
      },
    });
  };

  useEffect(() => {
    const storedPage = localStorage.getItem("editSitePagination");
    if (storedPage) {
      setPage(Number(storedPage));
    }
    getData({
      variables: {
        pageNumber: page,
        pageSize: 10,
        search,
      },
    });
  }, [page, search, getData]);

  const { tableDataCls, paginatedDataCls } = globalClasses;
  const tableModalRef = useRef();
  const headData = [
    globalVariables.dogName,
    globalVariables.breed,
    globalVariables.ownerName,
    globalVariables.birch,
    globalVariables.anise,
    globalVariables.clove,
    globalVariables.viewDogHistory,
  ];

  const onSearch = (event) => {
    const value = event?.target?.value;
    setSearch(value);
  };

  const debouncedSearch = debounce(onSearch, 1000);

  const DropdownList = ["Pass", "Miss"];
  const openModal = (trialIndex) => {
    setSelectedTrialIndex(trialIndex);
    tableModalRef.current.openModal();
  };

  const navigateDetails = (id, dogId, ownerName) => {
    navigate(`/host/editSiteDetails/${id}`, {
      state: { dogId: id, newDogId: dogId, ownerName },
    });
  };
  const modalRef = useRef();
  const onCloseModal = () => {};
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(null);

  const selectDropdown = async (id, value, key) => {
    try {
      setLoadingRowId(id);
      setLoadingStatus(key);
      const data = { [key]: value };
      const { data: mutationData } = await updateDogStatus({
        variables: {
          id,
          data,
        },
      });
      await refetch();

      setApiData({
        title: "Success",
        desc: mutationData.updateRegisteredDogSITStatus.message,
        type: "success",
      });

      modalRef.current.openModal();

      setLoadingRowId(null);
      setLoadingStatus(null);
    } catch (error) {
      console.error(error);
      setLoadingRowId(null);
      setLoadingStatus(null);
      setApiData({
        title: "error",
        desc: error.message,
        type: "pending",
      });
    }
  };

  const renderTableBody = () => {
    return filteredTableData?.map((data, index) => (
      <tr key={index}>
        <td className={paginatedDataCls(index)}>
          {data.call_name}
        </td>
        <td className={paginatedDataCls(index)}>{data.breed}</td>
        <td className={paginatedDataCls(index)}>{data.owner_name}</td>
        <td className={paginatedDataCls(index)}>
          <div className="grid place-items-center">
            {loadingRowId === data.id && loadingStatus === "birch" ? (
              <Loader />
            ) : (
              <Dropdown
                dropdownOptions={DropdownList}
                value={data.id}
                placeholder="Passed"
                width={"w-[125px]"}
                showIconRight
                defaultOption={data.birch == null ? "Select" : data.birch}
                onChange={(select) => selectDropdown(data.id, select, "birch")}
              />
            )}
          </div>
        </td>
        <td className={paginatedDataCls(index)}>
          <div className="grid place-items-center">
            {loadingRowId === data.id && loadingStatus === "anise" ? (
              <Loader />
            ) : (
              <Dropdown
                dropdownOptions={DropdownList}
                value={data.id}
                placeholder="Passed"
                width={"w-[125px]"}
                showIconRight
                defaultOption={data.anise == null ? "Select" : data.anise}
                onChange={(select) => selectDropdown(data.id, select, "anise")}
              />
            )}
          </div>
        </td>
        <td className={paginatedDataCls(index)}>
          <div className="grid place-items-center">
            {loadingRowId === data.id && loadingStatus === "clove" ? (
              <Loader />
            ) : (
              <Dropdown         
                dropdownOptions={DropdownList}
                value={data.id}
                placeholder="Passed"
                width={"w-[125px]"}
                showIconRight
                defaultOption={data.clove == null ? "Select" : data.clove}
                onChange={(select) => selectDropdown(data.id, select, "clove")}
              />
            )}
          </div>
        </td>
        <td
          className={`${paginatedDataCls(index)} text-center cursor-pointer`}
          onClick={() => {
            navigateDetails(data.id, data?.dog_id, data?.owner_name);
          }}
        >
          <div className="grid place-items-center cursor-pointer">
            <img src={externalLink} alt="link" />
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <div
      className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10"
      ref={modalRef}
    >
      <PageInfo title={globalVariables.editSit}/>
      <div className="flex flex-col gap-4 visible min-[480px]:hidden  ">
        <span className="text-xl font-semibold text-gray-900">
          {globalVariables.detailsDogs}
        </span>
        <SearchBar
          width="w-full"
          onChange={debouncedSearch}
          placeholder={globalVariables.search}
        />
      </div>
      {isMobile ? (
        <>
          {!loading && !error ? (
            <>
              {filteredTableData?.map((data, index) => (
                <div key={data.id} className="result-card-box">
                  <ResultCard {...data} onViewResult={() => openModal(index)} />
                </div>
              ))}
              {resultData?.totalPages > 1 ? (
                <MobilePagination
                  currentPage={resultData?.pageNumber}
                  totalPages={resultData?.totalPages}
                  handlePageChange={(page) => handlePaginationData(page)}
                />
              ) : (
                ""
              )}
            </>
          ) : loading ? (
            <Loader stroke="text-gradient-500" />
          ) : (
            <span>{error?.message}</span>
          )}
        </>
      ) : (
        <TableWithPagination
          headData={headData}
          headerComponent={
            <SearchBar
              onChange={debouncedSearch}
              placeholder={globalVariables.search}
            />
          }
          tableHeight={"md: h-[85vh] lg:h-[600px]"}
          paddingHorizontal="px-2"
          tableBody={renderTableBody()}
          itemsPerPage={10}
          totalPage={resultData?.totalPages}
          handlePageChange={(page) => handlePaginationData(page)}
          loading={loading}
          current={page}
          persistPagination={true}
          error={error}
          // overflow="overflow-visible"
        />
      )}
      <Modal ref={tableModalRef}>
        {selectedTrialIndex !== null && (
          <EditSitResultCard
            id={filteredTableData[0]?.id}
            DogName={
              filteredTableData[0]?.registration_name
                ? filteredTableData[0]?.registration_name
                : filteredTableData[0]?.call_name
            }
            breed={filteredTableData[0]?.breed}
            ownerName={filteredTableData[0]?.owner_name}
            birch={filteredTableData[0]?.birch}
            anise={filteredTableData[0]?.anise}
            clove={filteredTableData[0]?.clove}
            selectDropdown={selectDropdown}
            loadingRowId={loadingRowId}
            loadingStatus={loadingStatus}
            onDetail={() =>
              navigateDetails(
                filteredTableData[0]?.id,
                filteredTableData[0]?.dog_id
              )
            }
          />
        )}
      </Modal>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </div>
  );
};
